import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { Alert } from 'src/app/models/base-response';
import { Notification, NotificationConstantType } from 'src/app/models/notification';
import { AdminHeaderComponent } from 'src/app/layouts/admin-header/admin-header.component';
import { Router } from '@angular/router';
import { UserTransaction } from 'src/app/models/receivable';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-list-notification',
  templateUrl: './list-notification.component.html',
  styleUrls: ['./list-notification.component.css']
})
export class ListNotificationComponent implements OnInit {
  @ViewChild(AdminHeaderComponent) child: AdminHeaderComponent;

  limit: number = 100;
  notifs: Notification[] = [];
  transaction: UserTransaction = new UserTransaction();
  alertNotifs: Alert;
  isLoading: boolean = false;
  canShowMore: boolean = false;


  constructor(private notifService: NotificationService,
    private surveyService: SurveyService,
    private router: Router) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loadNotification();
  }

  loadNotification() {
    this.canShowMore = false;
    this.isLoading = true;
    this.notifService.getListNotification(this.limit, 0,
      resp => {
        this.isLoading = false;
        this.alertNotifs = resp.alert;
        if (resp.alert.code == 200) {
          // resp.data.forEach(item => {
          //   const createdDate = new Date(item.created_date);
          //   createdDate.setHours(createdDate.getHours() + 7);
          //   item.created_date = createdDate;

          //   item.string_created_date = this.notifService.getDiffTimeString(item.created_date);
          // });
          this.notifs = resp.data;
        }
      },
      err => {
        this.isLoading = false;
      });
  }

  showMore() {
    this.canShowMore = false;
    this.isLoading = true;
    this.notifService.getListNotification(this.limit, this.notifs.length,
      resp => {
        this.isLoading = false;
        this.alertNotifs = resp.alert;
        if (resp.alert.code == 200) {
          resp.data.forEach(item => {
            item.string_created_date = this.notifService.getDiffTimeString(item.created_date);
          });
          if (resp.data.length >= this.limit)
            this.canShowMore = true;
          this.notifs = this.notifs.concat(resp.data);
        }
      },
      err => {
        this.isLoading = false;
      });
  }

  action(data: Notification) {
    this.notifService.putNotification(data.id,
      resp => {
        this.loadNotification();
        this.child.loadNotification();
        this.child.loadNotificationCount();

        const notificationData = JSON.parse(data.data);
        if (notificationData.NotificationConstant === NotificationConstantType.NewInformation) {
          this.router.navigate(['/detail-promo/' + notificationData.ContextId]);
        } else if (notificationData.NotificationConstant === NotificationConstantType.PaymentInformation) {
          this.transaction.id = notificationData.ContextId;
          this.router.navigate([`/receivable/detail-payment/${btoa(JSON.stringify(this.transaction))}`]);
        } else if (notificationData.NotificationConstant === NotificationConstantType.ChangeLimit) {
          this.router.navigate(['/security/change-limit']);
        } else if (notificationData.NotificationConstant === NotificationConstantType.Survey) {
          this.surveyService.showSurvey(notificationData.ContextId);
        } else if (notificationData.NotificationConstant === NotificationConstantType.Order) {
          localStorage.setItem('transactionId', notificationData.ContextId);
          localStorage.setItem('typeTransaction', notificationData.NotificationConstant);
          this.router.navigate(['/transaction/']);
        } else if (notificationData.NotificationConstant === NotificationConstantType.PoolOrder) {
          localStorage.setItem('transactionId', notificationData.ContextId);
          localStorage.setItem('typeTransaction', notificationData.NotificationConstant);
          this.router.navigate(['/transaction/']);
        } else if (notificationData.NotificationConstant === NotificationConstantType.VoucherSuccess) {
          localStorage.setItem('voucherType', notificationData.NotificationConstant);
          this.router.navigate(['/reward']);
        } else if (notificationData.NotificationConstant === NotificationConstantType.VoucherFailed) {
          localStorage.setItem('voucherType', notificationData.NotificationConstant);
          this.router.navigate(['/reward']);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.OpenProposalSuccess
        ) {
          this.router.navigate([`/proposal/detail/${notificationData.ContextId}`]);
        } else {
          this.router.navigate(['/notification']);
        }
      },
      err => {
      });
  }

  markAllRead() {
    this.notifService.putAllNotification(
      resp => {
        this.loadNotification();
        this.child.loadNotification();
        this.child.loadNotificationCount();
      },
      err => { });
  }
}

